export default __webpack_public_path__ + "static/a80-0a24179957eb9b7bc2c34c16239a8742.webp";